<template>
  <div class="container-fluid">
    <TableControls :canSearch="false"/>
    <div class="form-group row">
      <div :class="edit ? 'col-md-10' : 'col-md-12'">
        <BaseInput
          type="text"
          v-model="set.name"
          :errorMessage="errorMessages['name']"
          placeholder="Enter name..."
          customClass="form-control-lg w-100"
        />
      </div>
      <div class="col-md-2 text-center" v-if="edit">
        <button class="preview-button" @click="openPreview()">
          <i class="far fa-eye"></i> Preview
        </button>
      </div>
    </div>
    <Modal v-show="previewModal" @close="previewModal = false" width="large">
      <h3 slot="header">Preview</h3>
      <div slot="body">
        <div id="daisy-offers" data-disabletracking="1" :data-setid="set.uuid">
          <!-- inject script -->
        </div>
      </div>
    </Modal>
    <!-- Start content -->
    <div class="row content-container">
      <div class="col-md-3 content-menu">
        <ul>
          <li
            v-if="set.showOnCreate"
            @click="selected = set.id"
            :class="{ 'active': set.id == selected }"
            v-for="set in setCreationTabs"
            :key="set.id"
          >
            <a >{{set.name}}</a>
          </li>
        </ul>
      </div>
      <!-- draggable -->
      <div class="col-md-9 content-section" v-if="selected === 1">
        <div class="offer-search-wrapper">
          <ul class="offer-input-list">
            <draggable class="drop-down-list" v-model="offer_uuids" @change="onMove">
              <li v-for="(offer, index) in offer_uuids" :key="index" class>
                <BaseIconTypeahead
                  v-model="selectedOffer[index]"
                  :placeholder="offer.name"
                  :results="offers"
                  :search="searchForAnOffer"
                  iconAppend="fas fa-trash-alt"
                  iconPreAppend="fas fa-arrows-alt-v"
                  @setvalue="addOfferUuid(selectedOffer[index], index)"
                  @delete="removeOfferFromSet(index)"
                />
              </li>
            </draggable>
          </ul>
        </div>

        <div class="d-flex justify-content-center mt-3">
          <BaseIconButton style-type="plus" @click.native="addOffer()"/>
        </div>
      </div>
      <!-- draggable -->
      <div class="col-md-9 content-section" v-else-if="selected === 2">
        <div class="form-row">
          <div class="form-group col-md-12">
            <label for="inputState">Font Family</label>
            <select id="inputState" class="form-control" v-model="appearanceOptions.fontFamily">
              <option v-for="(font, index) in fontUrls" :key="index" :value="font">{{font.name}}</option>
            </select>
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-md-6">
            <label for="inputColor">Button Background Color</label>
            <div class="input-group">
            <div class="input-group-prepend">
              <div class="">
              <input
              type="color"
              style="height:37px;width:50px;"
              class="form-control"
              v-model="appearanceOptions.buttonBackgroundColor"
            ></div>
            </div>
            <input
              type="text"
              style="height:37px"
              class="form-control"
              v-model="appearanceOptions.buttonBackgroundColor"
            >
          </div>
          </div>
          <div class="form-group col-md-6">
            <label for="inputColor">Button Font Color</label>
            <div class="input-group">
            <div class="input-group-prepend">
              <div class="">
              <input
              type="color"
              style="height:37px;width:50px;"
              class="form-control"
              v-model="appearanceOptions.buttonFontColor"
            ></div>
            </div>
            <input
              type="text"
              style="height:37px"
              class="form-control"
              v-model="appearanceOptions.buttonFontColor"
            >
          </div>
          </div>

        </div>
        <div class="form-row">
          <div class="form-group col-md-6">
            <label for="inputColor">Banner Background Color</label>
            <div class="input-group">
            <div class="input-group-prepend">
              <div class="">
              <input
              type="color"
              style="height:37px;width:50px;"
              class="form-control"
              v-model="appearanceOptions.bannerBackgroundColor"
            ></div>
            </div>
            <input
              type="text"
              style="height:37px"
              class="form-control"
              v-model="appearanceOptions.bannerBackgroundColor"
            >
          </div>
        </div>
          <div class="form-group col-md-6">
            <label for="inputColor">Banner Font Color</label>
          <div class="input-group-prepend">
              <div class="">
              <input
              type="color"
              style="height:37px;width:50px;"
              class="form-control"
              v-model="appearanceOptions.bannerFontColor"
            ></div>
            <input
              type="text"
              style="height:37px"
              class="form-control"
              v-model="appearanceOptions.bannerFontColor"
            >
            </div>
          </div>

        </div>
        <div v-if="showAdvanced" class="text-center mt-2 mb-2">
          <button class="hidden-button white" @click="showAdvanced = !showAdvanced">Hide advanced</button>
        </div>
        <div v-if="!showAdvanced" class="text-center mt-2 mb-2">
          <button class="hidden-button white" @click="showAdvanced = !showAdvanced">Show advanced</button>
        </div>
        <transition name="slide-fade">
          <div class>
            <!-- transition can only be used on single element? -->
            <PrismEditor
              v-if="showAdvanced"
              v-model="appearanceOptions.customScss"
              language="css"
              :lineNumbers="true"
            />
          </div>
        </transition>
      </div>
      <div class="col-md-9 content-section" v-else-if="selected === 3">
        <div class="form-group mt-2">
          <label for="exampleInputPassword1">Redirect Path</label>
          <BaseInput
            type="text"
            :error-message="errorMessages['redirect_url']"
            placeholder="https://example.com/thankyoupage"
            v-model="set.redirect_url"
          />
        </div>
      </div>
      <div class="col-md-9 content-section" v-else-if="selected === 4">
        <p
          class="p-0"
        >Click the code below to copy it to your clipboard, then paste it in your website.</p>
        <div class="input-group mt-2" id="copy-to-clipboard">
          <BaseButtonInput
            type="text"
            id="daisy-script"
            :icon="{ css: 'far fa-clipboard'}"
            v-model="script"
            :readonly="true"
            @fire="copyToClipboard()"
          />
        </div>
      </div>
    </div>

    <!-- End content -->
    <hr>
    <div class="d-flex flex-row justify-content-end">
      <BaseButton v-if="!edit" style-type="action" @click.native="createSet()">Create</BaseButton>
      <BaseButton v-else style-type="action" @click.native="updateSet()">Update</BaseButton>
      <router-link to="/sets" class="greyBtn">Cancel</router-link>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import draggable from 'vuedraggable'
import Sets from '@/resources/Sets.js'
import Offers from '@/resources/Offers.js'
import PrismEditor from 'vue-prism-editor'
const DAISY_URL = process.env.VUE_APP_DAISY_URL


export default {
  data() {
    return {
      errorMessages: {},
      showModal: false,
      previewModal: false,
      selected: 1,
      isActive: false,
      showAdvanced: false,
      showAdvanced2: false,
      results: null,
      term: '',
      setCreationTabs: [
        { name: 'Offer Order', id: 1, showOnCreate: true },
        { name: 'Appearance', id: 2, showOnCreate: true },
        { name: 'Completion', id: 3, showOnCreate: true },
        { name: 'Embed', id: 4, showOnCreate: false }
      ],
      set: {
        name: '',
        redirect_url: '',
        scss: '',
        offer_uuids: []
      },
      index: 0,
      offers: [],
      selectedOffer: [],
      offer_uuids: [{ offer_uuid: '', order: '', name: 'Search Offers' }],
      fontUrls: [
        { url: "https://fonts.googleapis.com/css?family=Roboto:400,700", value: 'Roboto', name: 'Roboto' },
        { url: "https://fonts.googleapis.com/css?family=Open+Sans:300,700", value: "'Open Sans'", name: "Open Sans" },
        { url: "https://fonts.googleapis.com/css?family=Lato:300,700", value: 'Lato', name: 'Lato' },
        { url: "https://fonts.googleapis.com/css?family=Montserrat:300,700", value: 'Montserrat', name: 'Montserrat' },
        { url: "https://fonts.googleapis.com/css?family=Raleway:300,700", value: 'Raleway', name: 'Raleway' },
        { url: "https://fonts.googleapis.com/css?family=Work+Sans:300,700", value: "'Work Sans'", name: "Work Sans" },
        { url: "https://fonts.googleapis.com/css?family=Merriweather:300,700", value: 'Merriweather', name: 'Merriweather' },
        { url: "https://fonts.googleapis.com/css?family=Lora:400,700", value: 'Lora', name: 'Lora' },
        { url: "https://fonts.googleapis.com/css?family=Lora:700|Roboto+Slab", value: "'Roboto Slab'", name: "Roboto Slab" }
      ],
      appearanceOptions: {
        buttonBackgroundColor: '#4C8D18',
        buttonFontColor: '#FFFFFF',
        bannerFontColor: '#FFFFFF',
        bannerBackgroundColor: '#29A0DA',
        fontFamily: { url: "https://fonts.googleapis.com/css?family=Roboto:400,700", value: 'Roboto', name: 'Roboto' },
        customScss: ''
      },
      edit: null
    }
  },
  computed: {
    scss() {
      let scss = `
          @import url("${this.appearanceOptions.fontFamily.url}");
          $fontFamily: ${this.appearanceOptions.fontFamily.value};
          $buttonBackgroundColor: ${this.appearanceOptions.buttonBackgroundColor};
          $buttonBackgroundHoverColor: darken($buttonBackgroundColor, 5%);
          $buttonFontColor: ${this.appearanceOptions.buttonFontColor};
          $bannerBackgroundColor: ${this.appearanceOptions.bannerBackgroundColor};
          $bannerFontColor: ${this.appearanceOptions.bannerFontColor};
          #daisy-offers { font-family: $fontFamily !important; }
          #daisy-offers { .dms-btn-primary { background-color: $buttonBackgroundColor !important; color: $buttonFontColor !important; &:hover { background-color: $buttonBackgroundHoverColor !important; } } }
          #daisy-offers { .dms-btn-primary:hover { background-color: $buttonBackgroundHoverColor !important; } }
          #daisy-offers { .dms-banner { background-color: $bannerBackgroundColor !important; h1,h2,h3,h4 {color: $bannerFontColor !important;} } }
      `
      scss += '/*custom*/' + this.appearanceOptions.customScss
      scss = scss.replace(/\n/g, '')
      return scss
    },
    script() {
      return `<div id="daisy-offers" data-setid="${this.set.uuid}"><script src="${DAISY_URL}/injector/daisy.js"></\script></div>`
    }
  },
  mounted() {
    this.canEdit()
  },
  methods: {
    canEdit(){
      this.edit = this.$route.params.id
        if (this.edit) {
          this.getSet(this.edit)
          this.setCreationTabs[3].showOnCreate = true
      }
    },
    openPreview() {
      this.previewModal = true
      let scriptEl = document.createElement('script')
      scriptEl.src = DAISY_URL + '/injector/daisy.js'
      let injectorEl = this.$el.querySelector('#daisy-offers')
      injectorEl.appendChild(scriptEl)
    },
    searchForAnOffer(event) {
      let searchObject = { search: event.target.value }
      Offers.filter(searchObject).then(res => {
        if (res) {
          this.offers = res.data
          this.hasResults = true
        }
      })
    },
    getAppearanceOptions(scss) {
      let fontName = /\$fontFamily:(.*?);/.exec(scss)[1] ? /\$fontFamily:(.*?);/.exec(scss)[1] : 'Roboto'
      let fontFamily = {}
      for (var i = 0; i < this.fontUrls.length; i++) {
        if (this.fontUrls[i].value === fontName) {
          fontFamily = this.fontUrls[i]
        }
      }
      this.appearanceOptions = {
        buttonBackgroundColor: /\$buttonBackgroundColor:(.*?);/.exec(scss)[1] ? /\$buttonBackgroundColor:(.*?);/.exec(scss)[1] : '#4C8D18',
        buttonFontColor: /\$buttonFontColor:(.*?);/.exec(scss)[1] ? /\$buttonFontColor:(.*?);/.exec(scss)[1] : '#fffff',
        bannerBackgroundColor: /\$bannerBackgroundColor:(.*?);/.exec(scss)[1] ? /\$bannerBackgroundColor:(.*?);/.exec(scss)[1] : '#29A0DA',
        bannerFontColor: /\$bannerFontColor:(.*?);/.exec(scss)[1] ? /\$bannerFontColor:(.*?);/.exec(scss)[1] : '#fffff',
        fontFamily: fontFamily,
        customScss: scss.split('/*custom*/').pop()
      }
    },
    toggleClass() {
      this.isActive = !this.isActive
    },
    addOffer() {
      this.selectedOffer.push({ uuid: '', name: '', order: '' })
      this.offer_uuids.push({ offer_uuid: '', order: '', name: 'Search Offers' })
      this.$forceUpdate()
    },
    cleanEmptyOffers() {
      for (var i = 0; i < this.set.offer_uuids.length; i++) {
        let offer = this.set.offer_uuids[i]
        if (!offer.offer_uuid) {
          this.set.offer_uuids.splice(i)
        }
      }
    },
    getSet(setId) {
      Sets.show(setId).then(res => {
        this.set = res
        this.set['offer_uuids'] = []
        for (let index = 0; index < this.set.offers.length; index++) {
          this.offer_uuids[index] = { offer_uuid: this.set.offers[index].uuid, order: this.set.offers[index].pivot.order, name: this.set.offers[index].name }
          this.selectedOffer[index] = { uuid: this.set.offers[index].uuid, name: this.set.offers[index].name }
        }
        this.getAppearanceOptions(this.set.scss)
      })
    },
    updateSet() {
      this.set.offer_uuids = this.offer_uuids
      this.cleanEmptyOffers()
      this.errorMessages = {}
      this.set.scss = this.scss
      Sets.patch(this.set.uuid, this.set).then(response => {
        if (response.error && response.status === 422) {
          this.errorMessages = response.body
        } else {
          this.$toast('Set updated.')
        }
      })
    },
    createSet() {
      this.errorMessages = {}
      this.set.offer_uuids = this.offer_uuids
      this.cleanEmptyOffers()
      this.set.scss = this.scss
      Sets.create(this.set).then(response => {
        if (response.error && response.status === 422) {
          this.errorMessages = response.body
        } else {
          this.$toast('Set created.')
          this.$router.replace(`/sets/edit/${response.uuid}`)
          this.canEdit()
        }
      })
    },
    addOfferUuid(offer, index) {
      this.offer_uuids[index] = { name: offer.name, offer_uuid: offer.uuid, order: index }
      this.offers = []
    },
    onMove() {
      for (let index = 0; index < this.offer_uuids.length; index++) {
        this.offer_uuids[index].order = index
      }
    },
    copyToClipboard() {
      this.$clip('daisy-script', 'set')
    },
    goToPreview() {
      // TODO: implement a preview
    },
    log(thing) {
      console.log(thing)
    },
    removeOfferFromSet(index) {
      this.offer_uuids.splice(index, 1)
    }
  },
  components: {
    draggable,
    PrismEditor
  }
}
</script>
<style lang="scss" scoped>
#copy-to-clipboard,
button {
  // height: 50px;
  // color: white;
  outline: none;
  border: none;
  background-color: $gray-100;
  &:hover {
    background-color: $gray-200;
  }
}
.copy {
  background-color: $gray-100;
  outline: none;
  border: none;
}
.fa-link {
  margin: 10px;
}
.custom-select {
  margin: 5px 0px 5px 5px;
}
.draggable {
  cursor: pointer;
}
.hidden-button {
  background-color: $container-bg;
  color: $mainColor;
  &:hover {
    background-color: $container-bg;
  }
}
.white {
  background-color: $white;
  &:hover {
    background-color: $white;
  }
}
.content-container {
  margin: 20px 0px 0px 0px;
  background-color: #fff;
  min-height: 415px;
}
.content-section {
  display: flex;
  flex-direction: column;
  margin: 20px 0px;
}
.preview-button {
  border: none;
  outline: none;
  font-size: 16px;
  padding: 10px;
  background-color: #f2f2f2;
  color: #99abb4;
  cursor: pointer;
  &:hover {
    font-size: 16.3px;
  }
  i:hover {
    font-size: 16.3px;
  }
}

.offer-search-wrapper {
  .offer-input-list {
    list-style-type: none;
    margin: 0px;
    padding: 0px;
    li {
      margin: 10px 5px;
    }
  }
}
</style>
